export const HEADQUARTERS_PERMISSIONS = {
  SHOW_DATA: 'show_headquarters',
  CREATE_DATA: 'create_headquarters',
  EDIT_DATA: 'edit_headquarters',
  CHANGE_STATE_DATA: 'change_state_headquarters',
  DELETE_DATA: 'delete_headquarters',
  EXPORT_EXCEL: 'export_headquarters',
  IMPORT_EXCEL: 'import_headquarters',
} as const;
export const HEADQUARTERS_PERMISSION_LIST = [
  HEADQUARTERS_PERMISSIONS.SHOW_DATA,
  HEADQUARTERS_PERMISSIONS.CREATE_DATA,
  HEADQUARTERS_PERMISSIONS.EDIT_DATA,
  HEADQUARTERS_PERMISSIONS.CHANGE_STATE_DATA,
  HEADQUARTERS_PERMISSIONS.DELETE_DATA,
  HEADQUARTERS_PERMISSIONS.EXPORT_EXCEL,
  HEADQUARTERS_PERMISSIONS.IMPORT_EXCEL,
] as const;
